/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { useMemo } from "react";

import { usePlayerComponents } from "../../../../../../shared/context/PlayerComponentsContext";
import { usePlayerTranslation } from "../../../../../../shared/context/PlayerTranslationContext";
import PlayIcon from "../../../../../../shared/icons/player/Play.svg";
import { MediaImageType } from "../../../../../../shared/types/enums";
import { getImageByType } from "../../../../../../shared/utils/image";
import { usePlayerCurrentMedia } from "../../../../../Controller";

import "./NextEpisodeDialog.scss";

export const NextEpisodeDialog = () => {
  const { nextMedia, loadNextMedia } = usePlayerCurrentMedia();
  const { Button } = usePlayerComponents();
  const { t } = usePlayerTranslation();

  const seasonAndEpisode = useMemo(() => {
    if (nextMedia?.OrderInParent) {
      if (nextMedia?.ParentOrderInParent) {
        return `S${nextMedia.ParentOrderInParent}E${nextMedia.OrderInParent}`;
      }

      return `E${nextMedia.OrderInParent}`;
    }

    return undefined;
  }, [nextMedia?.OrderInParent, nextMedia?.ParentOrderInParent]);

  const imageUrl = useMemo(() => {
    const image = getImageByType(nextMedia?.Images || [], MediaImageType.Cover);
    return image?.Url;
  }, [nextMedia?.Images]);

  if (!nextMedia) {
    return <></>;
  }

  return (
    <div className="NextEpisodeDialog">
      <div className="NextEpisodeDialog__Header">Next episode</div>
      <div className="NextEpisodeDialog__Content">
        <div className="NextEpisodeDialog__Content__Thumbnail">
          {imageUrl && (
            <img
              src={imageUrl}
              alt={nextMedia.Title || ""}
              className="NextEpisodeDialog__Content__Thumbnail__Image"
            />
          )}
          <div className="NextEpisodeDialog__Content__Thumbnail__Control">
            <Button
              variant="secondary"
              onClick={loadNextMedia}
              aria-label={t("PLAYER_BUTTON_NEXT_EPISODE")}
              iconOnly
            >
              <PlayIcon aria-hidden="true" focusable="false" />
            </Button>
          </div>
        </div>
        <div className="NextEpisodeDialog__Content__Metadata">
          <p>
            {seasonAndEpisode} | {nextMedia.Title}
          </p>
          <div
            className="NextEpisodeDialog__Content__Metadata__Description"
            dangerouslySetInnerHTML={{
              __html: nextMedia.ShortDescription || "",
            }}
          />
        </div>
      </div>
    </div>
  );
};
